(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herosekc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('doefit-background-hero')) {
    customElements.define('doefit-background-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.animations = [];
        this.played = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', (event) => this.scrollToTarget(event), { signal });
        this.addEventListener('focusin', () => this.finishAnimations(), { signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.finishAnimations(); }, { signal });
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this)) this.finishAnimations();
        }, { signal });
        if (this.dataset.animation === 'none' || this.motion.matches || !this.animate || !window.IntersectionObserver) return;
        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (!this.played || this.dataset.repeat === 'true') this.reveal();
              if (this.dataset.repeat !== 'true') this.observer.disconnect();
            }
          }
        }, { threshold: 0.05 });
        this.observer.observe(this);
      }

      reveal() {
        if (this.motion.matches || this.contains(document.activeElement)) return;
        this.animations.forEach((animation) => animation.cancel());
        this.played = true;
        const distance = Number(this.dataset.distance) || 0;
        let transform = 'none';
        let filter = 'none';
        switch (this.dataset.animation) {
          case 'up': transform = `translateY(${distance}px)`; break;
          case 'down': transform = `translateY(-${distance}px)`; break;
          case 'left': transform = `translateX(-${distance}px)`; break;
          case 'right': transform = `translateX(${distance}px)`; break;
          case 'zoom': transform = 'scale(0.96)'; break;
          case 'blur': filter = 'blur(8px)'; break;
        }
        this.animations = Array.from(this.querySelectorAll('[data-reveal]')).filter((element) => element.getClientRects().length).map((element, index) => {
          return element.animate([
            { opacity: 0, transform, filter },
            { opacity: 1, transform: 'none', filter: 'none' }
          ], {
            duration: Number(this.dataset.duration),
            delay: Number(this.dataset.delay) + index * Number(this.dataset.stagger),
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards'
          });
        });
      }

      finishAnimations() {
        this.animations.forEach((animation) => animation.cancel());
        this.observer?.disconnect();
        this.played = true;
      }

      scrollToTarget(event) {
        const link = event.target.closest('a[data-df-scroll]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const hash = link.getAttribute('href');
        if (!hash || !hash.startsWith('#')) return;
        let target;
        try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch { return; }
        if (!target) return;
        event.preventDefault();
        const offset = Number(this.dataset.scrollOffset) || 0;
        window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: this.motion.matches ? 'auto' : 'smooth' });
        if (!target.hasAttribute('tabindex') && !target.matches('a, button, input, select, textarea')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        try { history.replaceState(null, '', hash); } catch { /* Sandboxed preview. */ }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.animations?.forEach((animation) => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
